/**
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var core_1 = require("@blueprintjs/core");

var classNames = require("classnames");

var PureRender = require("pure-render-decorator");

var React = require("react");

var Classes = require("../common/classes");

var EditableName = function (_super) {
  tslib_1.__extends(EditableName, _super);

  function EditableName() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditableName.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        intent = _a.intent,
        name = _a.name,
        onCancel = _a.onCancel,
        onChange = _a.onChange,
        onConfirm = _a.onConfirm;
    return React.createElement(core_1.EditableText, {
      className: classNames(className, Classes.TABLE_EDITABLE_NAME),
      defaultValue: name,
      intent: intent,
      minWidth: null,
      onCancel: onCancel,
      onChange: onChange,
      onConfirm: onConfirm,
      placeholder: "",
      selectAllOnFocus: true
    });
  };

  return EditableName;
}(React.Component);

EditableName = tslib_1.__decorate([PureRender], EditableName);
exports.EditableName = EditableName;